/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { valorAPesos } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, ejecutarAccion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        nombre: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.nombre ? makeNiceText(item?.nombre) : "Sin nombre"}
            </SoftTypography>
          </SoftBox>
        ),
        totalPago: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.totalPago ? valorAPesos(item?.totalPago) : "Sin monto"}
            </SoftTypography>
          </SoftBox>
        ),
        totalRecargo: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.totalRecargo ? valorAPesos(item?.totalRecargo) : "Sin recargo"}
            </SoftTypography>
          </SoftBox>
        ),
        totalConRecargo: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.totalPago
                ? valorAPesos(item?.totalPago + item?.totalRecargo || 0)
                : "Sin monto"}
            </SoftTypography>
          </SoftBox>
        ),

        accion: (
          <SoftBox
            mr={2}
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            sx={{
              gap: 1,
            }}
          >
            <Tooltip title="Borrar" placement="top">
              <Icon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  ejecutarAccion("borrar", item);
                }}
              >
                cancel
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "nombre", desc: "Nombre", align: "left", noOrder: true },
  { name: "totalPago", desc: "Sin recargo", align: "center", noOrder: true },
  { name: "totalRecargo", desc: "Recargo", align: "center", noOrder: true },
  { name: "totalConRecargo", desc: "Final", align: "center", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
